import React from 'react'
import { InputNumber } from 'tea-component'

const NInputNumber: React.FC<any> = props => {
    const { field, ...rest } = props
    return <InputNumber { ...rest }/>
}
export default NInputNumber
